export default "__VITE_ASSET__e4634929__"